class AddressExtractor {

    static get NEEDED_FIELDS() {
        return [
            "street_number",
            "route",
            "sublocality_level_2",
            "sublocality_level_1",
            "locality",
            "administrative_area_level_1",
            "country",
            "postal_code",
            "postal_town"
        ]
    }

    static get ALIASES() {
        return {
            "billing_addr1": "line1",
            "billing_addr2": "line2",
            "billing_addr3": "line3",
            "billing_state": "state",
            "billing_region": "region",
            "billing_state_code": "state_code",
            "billing_zip": "zip",
            "billing_city": "city",
            "billing_country": "country"
        }
    }

    static extractAddress(addressComponents) {
        var extracted = this._extract(addressComponents);
        var output = {};
        output["line1"] = this._constructLine1(extracted);
        output["line2"] = this._constructLine2(extracted);
        output["line3"] = "";
        output["zip"] = this._test(extracted['postal_code']);
        output["country"] = extracted['country'] && extracted['country'].short_name;
        if (["GB", "SE"].indexOf(output["country"]) > -1) {
            output["city"] = this._test(extracted['postal_town']);
        } else {
            output["city"] = this._test(extracted['locality']);
        }
        if (["US", "CA", "IN"].indexOf(output["country"]) > -1) {
            output["state_code"] = extracted['administrative_area_level_1'] && extracted['administrative_area_level_1'].short_name;
        } else {
            output["state"] = this._test(extracted['administrative_area_level_1']);
        }
        output["region"] = ["US", "CA", "IN"].indexOf(output["country"]) > -1 ? output["state_code"] : output["state"];
        return output;
    }

    static _extract(addressComponents) {
        return addressComponents.reduce((map, value) => {
            var matchedType = value.types.filter((v) => this.NEEDED_FIELDS.indexOf(v) != -1)[0]
            if (matchedType && !map[matchedType]) {
                map[matchedType] = value;
            }
            return map;
        }, {})
    }

    static _constructLine1(extracted) {
        if(extracted['country'] && extracted['country'].short_name == "DE"){
            return [this._test(extracted["route"]), this._test(extracted["street_number"])].join(" ");
        }
        return [this._test(extracted["street_number"]), this._test(extracted["route"])].join(" ");
    }

    static _constructLine2(extracted) {
        return [this._test(extracted["sublocality_level_2"]), this._test(extracted["sublocality_level_1"])].filter(v => !!v).join(", ");
    }

    static _test(obj) {
        return obj && obj.long_name;
    }
}

export default AddressExtractor


// WEBPACK FOOTER //
// ./src/utils/address-extractor.js